import { PrivilegeChecker, Config } from 'omni-common-ui';
import { getProgressTestPlanFromIndex, isMarkable, checkIsUnitQuiz } from 'data/ProgressTestsPlan/accessors';
import Privileges from 'domain/Privileges';
import ProgressTestCourseView from './component';
import { actions as groupActions } from 'containers/Group';

const PT_VIEWER_NAME = 'Assessment Viewer';
const SHOW_MARK_BUTTON = false;

export default ({ getState }) => ({
  path: ':progressTestIndex/course(/:mode)',
  view: 'course',
  component: ProgressTestCourseView,
  sessionNavConfig: {
    setModeOnNavigate: '',
  },
  canAccess: (props) => {
    if (! ProgressTestCourseView.isInMarkingRoute(props)) {
      return true;
    }
    return PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.Edit);
  },
  breadcrumbLabels: ({ params }) => {
    if (params.mode === 'edit') return 'Edit';
    return [];
  },
  actionButtons: {
    default: {
      Mark: {
        route: './edit',
        visibleWhen: ({ location, params }) => {
          const isUnitQuiz = checkIsUnitQuiz(location.pathname);
          return SHOW_MARK_BUTTON && PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.Edit) &&
            isMarkable(getState(), params.groupId,
              Number.parseInt(params.progressTestIndex, 10), isUnitQuiz);
        },
        isPrimary: true,
      },
      [PT_VIEWER_NAME]: {
        label: () => {
          return Config.get('hf4OnlineHomeworkViewerUrl') ? PT_VIEWER_NAME : '';
        },
        newTab: true,
        linkHref: ({ location: { pathname }, params: { groupId, progressTestIndex } }) => {
          return buildAssessmentViewerUrl(getState(), groupId, progressTestIndex, pathname);
        },
        visibleWhen: ({ location: { pathname }, params: { groupId, progressTestIndex } }) => {
          const state = getState();

          if (groupActions.isSSCourseTypeGroup(state, groupId) ||
            groupActions.isNotTBv3Group(state, groupId)) {
            return false;
          }

          return !!buildAssessmentViewerUrl(state, groupId, progressTestIndex, pathname);
        },
        disableWhen: ({ location: { pathname }, params: { groupId, progressTestIndex } }) => {
          return !buildAssessmentViewerUrl(getState(), groupId, progressTestIndex, pathname);
        },
      },
    },
    edit: {
      Save: {
        isPrimary: true,
        route: '../save',
      },
      Discard: {
        route: '../discard',
      },
    },
  },
});

function getExamType(name) {
  if (name === 'Midterm Exam') return 'midterm';
  if (name === 'Final Exam') return 'final';
  return null;
}

function buildAssessmentViewerUrl(state, groupId, progressTestIndex, pathname) {
  const baseUrl = Config.get('hf4OnlineHomeworkViewerUrl');
  if (!baseUrl) return null;

  const isUnitQuiz = checkIsUnitQuiz(pathname);
  const plan = getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz);
  if (!plan) return null;

  const examType = getExamType(plan.name);
  if (!examType) return null;

  return `${baseUrl}/?type=${examType}&groupId=${groupId}`;
}



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/CourseView/routes.js